import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../store/useAuthStore'
import useRewardStore from '../../store/rewardStore'
import styles from '../../styles/user/SolverHeader.module.scss'

const CHARACTER_MAP = {
  explorer: '/assets/avatar/characters/Explorer.png',
  buddy: '/assets/avatar/characters/Buddy.png',
  thinker: '/assets/avatar/characters/Thinker.png',
}

const WrongQuizHeader = () => {
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const coins = useRewardStore((state) => state.coins)
  const gems = useRewardStore((state) => state.gems)
  const avatar = useRewardStore((state) => state.avatar)
  const fetchRewardSummary = useRewardStore((state) => state.fetchRewardSummary)

  useEffect(() => {
    if (user?.USER_ID) fetchRewardSummary(user.USER_ID).catch(() => {})
  }, [user?.USER_ID])

  const characterKey = (avatar?.character || 'explorer').toLowerCase()
  const characterImg = CHARACTER_MAP[characterKey] || CHARACTER_MAP.explorer
  const userName = user?.NAME || 'Student'

  return (
    <header className={styles.solverHeader}>
      <div
        className={styles.headerCard}
        style={{
          backgroundImage: "url('/assets/wrong-logo-bg.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Left: 로고 */}
        <div
          className={styles.logoSection}
          onClick={() => navigate('/dashboard/individual')}
          style={{ cursor: 'pointer' }}
        >
          <div className={styles.logoIconWrap}>
            <img src="/assets/white-logo.svg" alt="" className={styles.logoIconImg} />
          </div>
          <div className={styles.logoTextBlock}>
            <span className={styles.logoName}>Solution M</span>
            <span className={styles.logoSub}>kids math</span>
          </div>
        </div>

        {/* Center: 타이틀 */}
        <div className={styles.headerCenter}>
          <div className={styles.activityInfo}>
            <div
              className={styles.activityTitle}
              style={{
                color: '#5C2D00',
                textShadow: '0 1px 3px rgba(255, 255, 255, 0.5)',
              }}
            >
              Mistake Detective
            </div>
            <div
              className={styles.activityBadge}
              style={{
                background: 'rgba(92, 45, 0, 0.75)',
                borderColor: 'rgba(255, 255, 255, 0.4)',
              }}
            >
              Let's find what went wrong!
            </div>
          </div>
        </div>

        {/* Right: 보상 + 유저 */}
        <div className={styles.headerRight}>
          <div className={styles.rewardChip}>
            <img src="/assets/icons/coin.png" alt="coin" className={styles.rewardIcon} />
            <span className={styles.rewardValue}>{coins.toLocaleString()}</span>
          </div>
          <div className={styles.rewardDivider} />
          <div className={styles.rewardChip}>
            <img src="/assets/icons/gem.png" alt="gem" className={styles.rewardIcon} />
            <span className={styles.rewardValue}>{gems}</span>
          </div>
          <div className={styles.rewardDivider} />
          <div
            className={styles.userChip}
            onClick={() => navigate('/dashboard/individual')}
            style={{ cursor: 'pointer' }}
          >
            <img src={characterImg} alt="avatar" className={styles.userAvatar} />
            <div className={styles.userInfo}>
              <span className={styles.userName}>{userName}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default WrongQuizHeader
